import { type CVEditingSection } from '@cibli/shared';

import { useCVTranslation } from '@/features/cv/hooks/useCVTranslation.ts';

import EditableSection from '../../../components/form/EditableSection';
import { formatDriverLicense } from './helpers';

interface ContactSectionProps {
  email: string | null;
  phone: string;
  location: string;
  hasDriverLicense: boolean;
  driverLicenseTypes: string | null;
  openToTraining: boolean | null;
  onEdit?: (section: CVEditingSection) => void;
}

export default function ContactSection({
  email,
  phone,
  location,
  hasDriverLicense,
  driverLicenseTypes,
  openToTraining,
  onEdit,
}: ContactSectionProps) {
  const editable = onEdit !== undefined;
  const hasContact = email || phone || location || hasDriverLicense || openToTraining;
  const { t } = useCVTranslation();

  if (!hasContact && !editable) return null;

  const handleEdit = () => {
    if (onEdit) onEdit('personalInfos');
  };

  const driverLabel = formatDriverLicense(hasDriverLicense, driverLicenseTypes, t);

  const openToTrainingLabel = openToTraining ? t('Forms.PersonalInfo.openToTraining') : null;

  return (
    <EditableSection onEdit={handleEdit} editable={editable}>
      <div className="space-y-1">
        {phone && (
          <div className="text-[11px] text-current leading-relaxed">
            {/*<span className="font-bold">Portable :</span> */}
            {phone}
          </div>
        )}
        {email && (
          <div className="text-[11px] text-current leading-relaxed break-all">
            {/*<span className="font-bold">Email :</span>*/} {email}
          </div>
        )}
        {location && (
          <div className="text-[11px] text-current leading-relaxed">
            {/*<span className="font-bold">Ville :</span> */}
            {location}
          </div>
        )}
        {driverLabel && (
          <div className="text-[11px] text-current leading-relaxed">
            <span className="font-bold">{driverLabel}</span>
          </div>
        )}
        {openToTrainingLabel && (
          <div className="text-[11px] text-current leading-relaxed">
            <span className="font-bold">{openToTrainingLabel}</span>
          </div>
        )}
      </div>
    </EditableSection>
  );
}
